var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNormalLocationOnU30(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "13px",
    height: "18px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16 -23 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 6.3  C 13 2.8215  10.088928571428573 0  6.5 0  C 2.9110714285714283 0  0 2.8215  0 6.3  C 0 11.025  6.5 18  6.5 18  C 6.5 18  13 11.025  13 6.3  Z M 8.821428571428571 6.3  C 8.821428571428571 7.541999999999999  7.781428571428571 8.549999999999999  6.5 8.549999999999999  C 5.21857142857143 8.549999999999999  4.178571428571429 7.541999999999999  4.178571428571429 6.3  C 4.178571428571429 5.058000000000001  5.21857142857143 4.05  6.5 4.05  C 7.781428571428571 4.05  8.821428571428571 5.058000000000001  8.821428571428571 6.3  Z ",
    fillRule: "nonzero",
    fill: "#000000",
    stroke: "none",
    transform: "matrix(1 0 0 1 16 23 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalLocationOnU30);
export default __webpack_public_path__ + "static/media/normal_location_on_u30.a718fb2fb41755ac9e95af0a7f161826.svg";
export { ForwardRef as ReactComponent };